import { getID } from "src/libs/utilities"

 

const marriage = (): any[] => {
    return [
        {
          "id": getID( "marriage" ),
          "type": "marriage",
          "height": 790,
          "animated": ["fadeInUp"],
          "animated_delay": "waterfall",
          "design_type": 2,
          "hover_size": 5, 
          image0:  {
            "src": "https://i.pinimg.com/736x/26/83/c3/2683c3c61f42eefae1836268def57a3a.jpg",
            "link_url--": "https://ru.pinterest.com/pin/8585055536041984/",
            "link_target": "_blank",
            "title": "Red panda",
            "src_type": "div"
          },
          image1:  {
            "src": "https://i.pinimg.com/736x/98/70/73/987073a1c1ae6fbaed9aef980f882550.jpg",
            "link_url--": "https://ru.pinterest.com/pin/5559199537687963/",
            "link_target": "_blank",
            "title": "Выдро",
            "src_type": "div"
          },
          image2:  {
            "src": "https://i.pinimg.com/736x/41/37/ef/4137efbe5fbe7b936e835f7758ec0c6f.jpg",
            "link_url--": "https://ru.pinterest.com/pin/101964379058549867/",
            "link_target": "_blank",
            "title": "koalo",
            "src_type": "div"
          },
          image3:  {
            "src": "https://i.pinimg.com/736x/b2/65/fb/b265fbf3087b7da936476831b61a8015.jpg",
            "link_url--": "https://ru.pinterest.com/pin/8796161768575565/",
            "link_target": "_blank",
            "title": "kurva",
            "src_type": "div"
          },
          image4:  {
            "src": "https://i.pinimg.com/1200x/a1/03/f6/a103f6388451fad864b156a98f4592fc.jpg",
            "link_url--": "https://ru.pinterest.com/pin/14425661317798168/",
            "link_target": "_blank",
            "title": "soroka",
            "src_type": "div"
          },
          image5:  {
            "src": "https://i.pinimg.com/1200x/5d/8b/31/5d8b31b3546c4e4b4c98aa4dc1d9712b.jpg",
            "link_url--": "https://ru.pinterest.com/pin/70437489268050/",
            "link_target": "_blank",
            "title": "avis",
            "src_type": "div"
          },
          image6:  {
            "src": "https://i.pinimg.com/1200x/8a/df/e0/8adfe0e948eae8af71c7302ce0e6ccb1.jpg",
            "link_url--": "https://ru.pinterest.com/pin/8092474325643875/",
            "link_target": "_blank",
            "title": "rabbit",
            "src_type": "div"
          },
          image7:  {
            "src": "https://i.pinimg.com/736x/5c/07/22/5c072267cffd6b194b58b4984464fc14.jpg",
            "link_url--": "https://ru.pinterest.com/pin/15762667443067172/",
            "link_target": "_blank",
            "title": "goloob",
            "src_type": "div"
          },
          image8:  {
            "src": "https://i.pinimg.com/736x/4e/11/17/4e1117005486bb8b5d41c081d4cddc1d.jpg",
            "link_url--": "https://ru.pinterest.com/pin/5699937023283763/",
            "link_target": "_blank",
            "title": "cat",
            "src_type": "div"
          },
          image9:  {
            "src": "https://i.pinimg.com/736x/0e/bc/4f/0ebc4f7416540ddcf280d078d4cba08e.jpg",
            "link_url--": "https://ru.pinterest.com/pin/8092474325643875/",
            "link_target": "_blank",
            "title": "avis",
            "src_type": "div"
          },
          "text": {
            "text": "<p>Раз уж у нас тут случились дни Ведьмака, приуроченные к презентации подарочного издания, то давайте вспомним и первые иллюстрации.<p>Были они опубликованы в 9 выпуске «Приключения и Фантастика», который считался «библиотечкой «Уральского следопыта». Это июль или август (тут могу напутать) 1990 года.<p>Вообще «ПиФ» был шикарным эээ... сборником, я затрудняюсь позиционировать это издание на газетной бумаге в 32 страницы в нынешних координатах. Впрочем, это неудивительно, делала его легендарная команда «Уральского следопыта».<p>Иллюстрации к рассказу «Дорога с которой не возвращаются» сделал Дмитрий Литвинов.<p>На горячую линию взяли работать ангела.<p>Он сутулился, был близоруким, всегда опаздывал.<p>В первый день насмешил — уходя, мол, гасите факелы,<p>Удивленного шефа назвал по привычке пастырем.<p>За спиной все коллеги негласно считали чудиком.<p>Как-то звали его — то ли Ванькою, то ли Яковом.<p>Вперемешку с карандашами торчали лютики.<p>В телефонную трубку кричали, но чаще плакали.",
            "link_url--": "https://ru.pinterest.com/pin/36802921956067509/",
            "link_target": "_blank",
            "height": 360
          },
          defaultTitle: "Марьяж 10 картинок, текст снизу"
        },
        {
          "id": getID( "marriage" ),
          "type": "marriage",
          "height": 700,
          "animated": ["fadeInUp"],
          "animated_delay": "waterfall",
          "design_type": 0,
          "hover_size": 5,
          image0:  {
            "src": "https://i.pinimg.com/736x/a4/68/7f/a4687fdf1e8f550e3b9d2393ad4abc14.jpg",
            "link_url--": "https://ru.pinterest.com/pin/1196337398412896/",
            "link_target": "_blank",
            "title": "owl",
            "src_type": "div"
          },
          image1:  {
            "src": "https://i.pinimg.com/736x/75/4d/38/754d389afeb305ba29b755dabeae0b4e.jpg",
            "link_url--": "https://ru.pinterest.com/pin/37647346880573812/",
            "link_target": "_blank",
            "title": "dino",
            "src_type": "div"
          },
          image2:  {
            "src": "https://i.pinimg.com/1200x/03/a1/d5/03a1d564896d345ac87a138ce30a8bcf.jpg",
            "link_url--": "https://ru.pinterest.com/pin/7529524369607691/",
            "link_target": "_blank",
            "title": "ape",
            "src_type": "div"
          },
          image3:  {
            "src": "https://i.pinimg.com/736x/2c/c6/fe/2cc6fe3a4f9ad9687da9e7a5a1765864.jpg",
            "link_url--": "https://ru.pinterest.com/pin/1125968725514307/",
            "link_target": "_blank",
            "title": "fishs",
            "src_type": "div"
          },
          image4:  {
            "src": "https://i.pinimg.com/736x/03/61/24/036124c63ccb08d6f061d6eddd030504.jpg",
            "link_url--": "https://ru.pinterest.com/pin/24136547999863843/",
            "link_target": "panda",
            "title": "avis",
            "src_type": "div"
          },
          image5:  {
            "src": "https://i.pinimg.com/736x/bd/d4/ae/bdd4ae527a7a4f84debb77e91cbe3b47.jpg",
            "link_url--": "https://ru.pinterest.com/pin/351912465946198/",
            "link_target": "_blank",
            "title": "bears",
            "src_type": "div"
          },
          image6:  {
            "src": "https://i.pinimg.com/736x/78/13/95/781395e692ee4db2b622c4cbeb6e4468.jpg",
            "link_url--": "https://ru.pinterest.com/pin/10203536651661084/",
            "link_target": "_blank",
            "title": "giraff",
            "src_type": "div"
          },
          image7:  {
            "src": "https://i.pinimg.com/1200x/5d/8b/31/5d8b31b3546c4e4b4c98aa4dc1d9712b.jpg",
            "link_url--": "https://ru.pinterest.com/pin/70437489268050/",
            "link_target": "rabbit",
            "title": "avis",
            "src_type": "div"
          },
          image8:  {
            "src": "https://i.pinimg.com/736x/57/05/b1/5705b1a2027b960c015432ed643a3b01.jpg",
            "link_url--": "https://ru.pinterest.com/pin/5699937023283763/",
            "link_target": "_blank",
            "title": "fox",
            "src_type": "div"
          },
          image9:  {
            "src": "https://i.pinimg.com/1200x/8a/df/e0/8adfe0e948eae8af71c7302ce0e6ccb1.jpg",
            "link_url--": "https://ru.pinterest.com/pin/8092474325643875/",
            "link_target": "rabbit",
            "title": "avis",
            "src_type": "div" 
          },
          "text": {
            "text": "<p>Немецкий дог – замечательная порода, которую по ряду причин не спешат заводить у себя дома даже опытные любители собак. При всех многочисленных достоинствах хвостатого друга человека, есть у немецкого дога и такие качества, которые заставляют задуматься о рациональности выбора щенка данной породы в собственном доме.<p>Заводить немецкого дога в квартире или доме, когда уже есть какой-либо питомец крупнее хомяка или попугая – не самая лучшая идея. Все потому, что гордая собака чрезвычайно ревнива. Едва ли она дойдет до прямой агрессии к конкуренту, однако гиперактивность в отношении хозяина со стороны немецкого дога гарантирована. Стройный красавчик всеми силами будет стараться напомнить о своем существовании при первом удачном случае.",
            "link_url--": "https://ru.pinterest.com/pin/36802921956067509/",
            "link_target": "_blank"
          },
          defaultTitle: "Марьяж 10 картинок, текст снизу"
        },
        {
          "id": getID( "marriage" ),
          "type": "marriage",
          "height": 700,
          "animated": ["fadeInUp"],
          "animated_delay": "waterfall",
          "design_type": 1,
          "hover_size": 5,
          image0:  {
            "src": "https://i.pinimg.com/1200x/ac/eb/5b/aceb5bc921caaf1a384b8a62c8abbabd.jpg",
            "link_url--": "https://ru.pinterest.com/pin/36802921956067509/",
            "link_target": "_blank",
            "title": "Two crows",
            "src_type": "div"
          },
          image1:  {
            "src": "https://i.pinimg.com/1200x/73/3f/72/733f72e2ebaf6e29bd5f7bdaaab8ec8b.jpg",
            "link_url--": "https://ru.pinterest.com/pin/8373949303037188/",
            "link_target": "_blank",
            "title": "bee",
            "src_type": "div"
          },
          image2:  {
            "src": "https://i.pinimg.com/736x/92/5b/94/925b94eece7dce34a0e896602ee55f88.jpg",
            "link_url--": "https://ru.pinterest.com/pin/119767671334023518/",
            "link_target": "_blank",
            "title": "octopus",
            "src_type": "div"
          },
          image3:  {
            "src": "https://i.pinimg.com/1200x/7a/b7/1a/7ab71a03d8eff5dd524666f0f23e9ea5.jpg",
            "link_url--": "https://ru.pinterest.com/pin/3588874697313193/",
            "link_target": "_blank",
            "title": "monkey",
            "src_type": "div"
          },
          image4:  {
            "src": "https://i.pinimg.com/736x/18/66/c9/1866c9066526fec808f143cf87b70d08.jpg",
            "link_url--": "https://ru.pinterest.com/pin/5770305769131366/",
            "link_target": "_blank",
            "title": "avis",
            "src_type": "div"
          },
          image5:  {
            "src": "https://i.pinimg.com/1200x/03/22/a9/0322a9700f30b7fb0620fb27cddebad1.jpg",
            "link_url--": "https://ru.pinterest.com/pin/3799980930645859/",
            "link_target": "_blank",
            "title": "eye",
            "src_type": "div"
          },
          image6:  {
            "src": "https://i.pinimg.com/736x/72/cf/64/72cf64d15e782b9cfe74b52315985c28.jpg",
            "link_url--": "https://ru.pinterest.com/pin/54113633029112515/",
            "link_target": "_blank",
            "title": "duck",
            "src_type": "div"
          },
          image7:  {
            "src": "https://i.pinimg.com/736x/47/62/d0/4762d001c11f7b6aafbdc1439ed73cfb.jpg",
            "link_url--": "https://ru.pinterest.com/pin/37154765667831070/",
            "link_target": "_blank",
            "title": "ape",
            "src_type": "div"
          },
          image8:  {
            "src": "https://i.pinimg.com/736x/cb/59/5f/cb595fef990554b340e798305bbe054b.jpg",
            "link_url--": "https://ru.pinterest.com/pin/53691420551771999/",
            "link_target": "_blank",
            "title": "hameleon",
            "src_type": "div"
          },
          image9:  {
            "src": "https://i.pinimg.com/1200x/02/d3/ee/02d3ee59fefa38acb133c726f148feae.jpg",
            "link_url--": "https://ru.pinterest.com/pin/17732992276498058/",
            "link_target": "_blank",
            "title": "byk",
            "src_type": "div"
          },
          "text": {
            "text": "<p>Немецкий дог – замечательная порода, которую по ряду причин не спешат заводить у себя дома даже опытные любители собак. При всех многочисленных достоинствах хвостатого друга человека, есть у немецкого дога и такие качества, которые заставляют задуматься о рациональности выбора щенка данной породы в собственном доме.<p>Заводить немецкого дога в квартире или доме, когда уже есть какой-либо питомец крупнее хомяка или попугая – не самая лучшая идея. Все потому, что гордая собака чрезвычайно ревнива. Едва ли она дойдет до прямой агрессии к конкуренту, однако гиперактивность в отношении хозяина со стороны немецкого дога гарантирована. Стройный красавчик всеми силами будет стараться напомнить о своем существовании при первом удачном случае.",
            "link_url--": "https://ru.pinterest.com/pin/36802921956067509/",
            "link_target": "_blank"
          },
          defaultTitle: "Марьяж 10 картинок, текст ввержу"
        }
    ]
}

export default marriage